import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';

// api
import AuthenticationService from '../../service/authentication-service';

// tools
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';
import { hasDetailMessages, transformAndDisplay } from '../../helpers/transformErrorResponse';
import handleErrorAndDisplay from '../../helpers/handleErrorAndDisplay';

// components
import LogoIcon from '../../icons/LogoIcon';
import { useForm } from 'react-hook-form';
import FormField from '../../components/FormField';
import ButtonFormSubmit from '../../components/ButtonWrapper/components/ButtonFormSubmit';

const ResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        formState: { isValid }
    } = useForm({ mode: 'onChange' });

    const onSubmit = (formData) => {
        setLoading(true);

        AuthenticationService.forgotPassword(formData, callback, errCallback)
    };

    const callback = () => {
        handleSuccessAndDisplay(__('Check your email!', 'soundbetween'))
        setLoading(false);
    }

    const errCallback = (resp) => {
        if (hasDetailMessages(resp)) {
            transformAndDisplay(handleErrorAndDisplay, resp);
        }
        setLoading(false);
    }

    // Email validation rules
    const emailValidationRules = {
        required: __('Email is required', 'soundbetween'),
        pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: __('Enter a valid email', 'soundbetween')
        }
    };

    return (
        <div className={['appPage', 'appPageLogin'].join(' ')}>
            <div className="appPageLogin__wrapper">

                <LogoIcon/>

                <div className="loginCard">
                    <span className="loginCard__title">{__('Forgot password?', 'soundbetween')}</span>
                    <span className="loginCard__subttitle">
                        {__('Enter your email', 'soundbetween')}
                    </span>

                    <form className="appForm" onSubmit={handleSubmit(onSubmit)} noValidate>
                        <fieldset>
                            <FormField
                                type="email"
                                name="email"
                                placeholder={__('Email', 'soundbetween')}
                                control={control}
                                rules={emailValidationRules}
                            />
                        </fieldset>

                        <ButtonFormSubmit onClick={() => {}} disabled={loading || !isValid}>
                            {__('Confirm', 'soundbetween')}
                        </ButtonFormSubmit>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;